import React from 'react'
import { useStoreState } from 'easy-peasy'

import { Layout } from './Layout'
import { LoginForm } from './LoginForm'

import { Box } from 'system'

export const AuthenticatedLayout = props => {
  const authStage = useStoreState(state => state.auth.authStage)

  switch (authStage) {
    case 'INIT':
      return <Box bg="purple.100" minHeight="100vh" minWidth="100vw" />

    case 'SIGNED_OUT':
      return (
        <Layout withHeader={false} {...props}>
          <LoginForm />
        </Layout>
      )

    case 'VERIFYING_JWT':
      return <Box bg="purple.100" minHeight="100vh" minWidth="100vw" />

    case 'SIGNED_IN':
      return <Layout {...props} />

    default:
      throw new Error('We are rendering an unhandled authStage')
  }
}

export default AuthenticatedLayout
